import _ from 'lodash-es';
import APIV5 from '~/models/api';

export default class KpathController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 */
	constructor(
		$element,
		$timeout,
		$translate,
	) {
		this.$element = $element;
		this.$timeout = $timeout;
		this.$translate = $translate;

		/** @type {?Function} */
		this.onAdd = null;

		/** @type {?Function} */
		this.onChange = null;

		/** @type {?Function} */
		this.onDelete = null;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {any[]} */
		this.expandedNodes = [];

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {any} */
		this.mf = {
			value:       [],
			kpath:       {
				kid: this.kid,
				cur: null,
			},
			placeholder: '',
		};

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {{display: 'tree' | 'breadcrumb', mode: 'kpath' | 'class' }} */
		this.options = {
			display: 'tree',
			mode:    'kpath',
		};

		/** @type {?import('../kform/kform.controller').default} */
		this.parent = null;

		/** @type {string} */
		this.placeholder = '';

		/** @type {boolean} */
		this.required = false;

		/** @type {any[]} */
		this.treeData = [];

		/** @type {any} */
		this.treeOptions = {
			isLeaf:        (/** @type {any} */ node) => node.children.length === 0,
			nodeChildren:  'children',
			dirSelectable: false,
			injectClasses: {
				// ul:            'a1',
				li:         (/** @type {any} */ node) => this.#getBranchClass(node),
				// liSelected:    'a7',
				iExpanded:  'fa text-primary fa-minus-circle',
				iCollapsed: 'fa text-primary fa-plus-circle',
				// iLeaf:         'a5',
				// label:         'a6',
				// labelSelected: 'a8'
			},
		};

		/** @type {?number} */
		this.validatorPathMin = null;

		/** @type {?number} */
		this.validatorPathMax = null;

		/** @type {any} */
		this.values = undefined;
	}

	/**
	 * @param {any} parent
	 */
	#addNodeCreate(parent) {
		if (this.options.mode === 'class') {
			this.#recPush(this.treeData, {
				kid:               '__create',
				name:              'Select a child',
				children:          [],
				availableChildren: [],
				parent,
			}, parent);
		}
	}

	// noinspection JSMethodCanBeStatic
	/**
	 * @param {any} node
	 * @returns {string | undefined}
	 */
	#getBranchClass(node) {
		return node.flow ? `link-flow-${node.flow}` : undefined;
	}

	/**
	 * @param {any[]} tree
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	#recPop(tree, kid) {
		if (!kid) {
			tree.length = 0;
		}
		else if (tree[0].kid === kid) {
			tree[0].children.length = 0;
		}
		else if (tree[0].children.length > 0) {
			this.#recPop(tree[0].children, kid);
		}
	}

	/**
	 * @param {any[]} tree
	 * @param {any} item
	 * @param {any} parent
	 */
	#recPush(tree, item, parent) {
		item.parent = parent;
		if (tree.length > 0 && tree[0].children) {
			this.#recPush(tree[0].children, item, tree[0].kid);
		}
		else {
			tree.push(item);
			if (!this.expandedNodes.some(n => n.kid === item.kid)) {
				this.expandedNodes.push(item);
			}
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.disabled) {
			// this.readOnly = changes.disabled.currentValue;
		}

		if (changes.kid) {
			this.mf.kpath.kid = changes.kid.currentValue;
		}

		if (this.ngModelCtrl && (changes.validatorPathMin || changes.validatorPathMax)) {
			this.ngModelCtrl.$validate();
		}
	}

	$onInit() {
		if (this.kid) {
			this.mf.kpath.kid = this.kid;
		}

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$formatters.push(modelValue => {
				this.treeData.length = 0;
				let parent = null;
				for (const item of (modelValue || [])) {
					if (item?.kid) {
						const item2 = _.merge({}, item);
						item2.children = [];
						this.mf.kpath.cur = item2.kid;
						this.#recPush(this.treeData, item2, parent);
						parent = item.kid;
					}
				}

				this.#addNodeCreate(parent);

				// this.values = angular.copy(modelValue || []);
				return modelValue;
			});

			this.ngModelCtrl.$validators.required = (modelValue, viewValue) => {
				let valid = true;
				if (this.required === true && (!viewValue || (Array.isArray(viewValue) && viewValue.length === 0))) {
					valid = false;
					if (!this.ngModelCtrl?.$pristine) {
						this.$translate('error.missing-kpath').then(error => {
							this.error = error;
							return true;
						}).catch(() => {});
					}
				}

				if (valid) {
					this.error = null;
				}

				return valid;
			};

			this.ngModelCtrl.$validators.pathMax = (modelValue, viewValue) => {
				let valid = true;
				if (typeof this.validatorPathMax === 'number' && Array.isArray(viewValue)) {
					valid = viewValue.length <= this.validatorPathMax;
				}
				return valid;
			};

			this.ngModelCtrl.$validators.pathMin = (modelValue, viewValue) => {
				let valid = true;
				if (typeof this.validatorPathMin === 'number' && Array.isArray(viewValue)) {
					valid = viewValue.length >= this.validatorPathMin;
				}
				return valid;
			};
		}
	}

	/**
	 * @param {any} item
	 * @param {any} replaceCreateItem
	 */
	addValue(item, replaceCreateItem) {
		if (item) {
			const element = {
				kid:        item.kid,
				linker_kid: item.linker_kid,
				flow:       item.flow || 'down',
				name:       item.name,
				children:   [],
			};

			this.mf.kpath.cur = item.kid;
			this.mf.placeholder = item.name;

			if (!Array.isArray(this.values)) {
				console.warn('fix array', this.values);
				this.values = [];
			}

			this.values.push(_.merge({}, {
				kid:        item.kid,
				linker_kid: item.linker_kid,
				name:       item.name,
				flow:       item.flow,
			}));
			if (replaceCreateItem) {
				_.merge(replaceCreateItem, element);
				if (this.options.mode === 'class') {
					this.#addNodeCreate(item.kid);
				}
			}
			else {
				this.#recPush(this.treeData, element, item.parent);
			}

			this.$timeout(() => {
				this.mf.value = [];
				if (typeof this.onAdd === 'function') {
					this.onAdd({ child: item });
				}
			});
		}

		this.updateModel();
	}

	/**
	 * @param {Event} event
	 */
	delLastItem(event) {
		event.stopImmediatePropagation();
		event.preventDefault();
		this.values.pop();
		this.mf.kpath.cur = this.values.length > 0 ? this.values.at(-1).kid : null;
		this.#recPop(this.treeData, this.mf.kpath.cur);
		this.#addNodeCreate(this.mf.kpath.cur);
		this.updateModel();
		this.$timeout(() => {
			this.mf.value = [];
			if (typeof this.onDelete === 'function') {
				this.onDelete({ child: this.values.at(-1) });
			}
		});
	}

	/**
	 * @param {any} open
	 * @param {any} node
	 */
	async dropdownCreateToggled(open, node) {
		if (open && node.availableChildren.length === 0 && this.values) {
			// get the last value kid
			const nodeid = this.values.at(-1).kid;
			const options = {
				parentid: node.parent,
			};

			const children = await APIV5.instance.mfChildren2(
				nodeid,
				'QUERY',
				options,
				{
					id: 'kpath.dropdown-create-toggled',
				});
			this.$timeout(() => {
				node.availableChildren.push(...children.result);
			});
		}
	}

	updateModel() {
		this.ngModelCtrl?.$setViewValue(this.values);
		this.ngModelCtrl?.$validate();
		this.$element.trigger('change');
		this.$timeout(() => {
			if (typeof this.onChange === 'function') {
				this.onChange();
			}
		});
	}
}
